<template>
    <div @click="activateModal" :id="item.id" :class="['menu-card', {'menu-card--saved': saved}]">
        <div class="menu-card__img">
            <img v-if="!item.icon" src="@/assets/images/placeholder-icon.png" :alt="item.name" />
            <img v-else :src="`${apiUri}${item.icon}`" :alt="item.name" />
        </div>

        <div class="menu-card__info">
            <div class="menu-card__title">{{ item.name }}</div>
            <div class="menu-card__text" v-html="formatValueWithUnit(item.price.value, item.price.unit)"></div>
        </div>

        <label v-if="mulitchoice == 'true'" @click.stop :for="'checkbox-' + item.id" class="checkbox">
            <input type="checkbox" 
                @change.stop="toggleSelect(item.id)" 
                :checked="saved || selected" 
                :id="'checkbox-' + item.id" 
                class="input input--checkbox"
            >
            <div class="checkbox__icon"></div>
        </label>
    </div>
</template>

<script>
export default {
    name: 'MenuCard',
    props: ['item', 'saved', 'selected', 'mulitchoice'],
    inject: ['formatValueWithUnit'],
    emits: ['select-material', 'add-material'],
    computed: {
        apiUri() {
            return process.env.VUE_APP_APOLLO_API_URI;
        }
    },
    methods: {
        activateModal(event) {
            this.$emit('select-material', event.currentTarget.id);
        },
        toggleSelect(id) {
            this.$emit('add-material', id);
        }
    }
}
</script>
